export function useAccordions() {
  function Accordions(acc, autoClose) {
    if (!(acc instanceof Element)) {
      return;
    }

    const accordionBtns = acc.querySelectorAll(".accordions__button");
    const accordionPanels = acc.querySelectorAll(".accordions__panel");

    function setPanelHeights() {
      accordionPanels.forEach((panel) => {
        const panelTextHeight =
          panel.querySelector(".accordions__text").offsetHeight;
        panel.style.setProperty("--accordionHeight", `${panelTextHeight}px`);
      });
    }

    function open(btn) {
      btn.setAttribute("aria-expanded", true);

      const wrapper = btn.closest(".accordions__item");
      wrapper.classList.add("active");
    }

    function close(btn) {
      btn.setAttribute("aria-expanded", false);

      const wrapper = btn.closest(".accordions__item");
      wrapper.classList.remove("active");
    }

    function closeAllPanels() {
      accordionBtns.forEach((btn) => close(btn));
    }

    function toggle(e) {
      const btn = e.currentTarget;
      const active = btn.getAttribute("aria-expanded") === "true";

      autoClose && closeAllPanels();
      if (active) {
        close(btn);
      } else {
        open(btn);
      }
    }

    // Initialize

    const accordionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach(() => {
        setPanelHeights();
      });
    });
    accordionResizeObserver.observe(acc);

    accordionBtns.forEach((btn) => {
      btn.addEventListener("click", toggle);
    });
  }

  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((acc) => {
    const autoClose = acc.dataset.autoClose === "true";
    Accordions(acc, autoClose);
  });
}
